<script setup>
const props = defineProps(['model', 'search', 'filter'])
const emit = defineEmits(['removeFilter', 'addFilter'])
const appConfig = useAppConfig()
const isInteracted = ref(false)
const isUserExpanded = ref(false)

const isExpanded = computed(() => {
  if (isInteracted.value) {
    return isUserExpanded.value
  }
  else {
    if (props.filter && props.filter.options && props.filter.options.length > 0) {
      return true
    }
    else {
      return false
    }
  }
})

const optionList = computed(() => {
  if (!props.search?.options || !props.model?.options?.expandedValue) {
    return []
  }

  const searchOptionSet = new Set(
    props.search.options.map(o => o.urlName),
  )

  return props.model.options.expandedValue.filter(option =>
    searchOptionSet.has(option.optionUrlName.value),
  )
})

function toggleExpansion() {
  isInteracted.value = true
  isUserExpanded.value = !isExpanded.value
}

function removeFilter(optionName) {
  emit('removeFilter', props.model.categoryUrl.value, optionName)
}

function addFilter(optionName) {
  emit('addFilter', props.model.categoryUrl.value, optionName)
}
</script>

<template>
  <div class="border-t-2 border-med-light-aqua">
    <div>
      <button
        class="w-full"
        @click="toggleExpansion"
      >
        <div class="flex justify-between py-3">
          <span class="text-left">
            <span class="font-medium text-base text-med-navy">
              {{ model.title.value }}
            </span>
            <span
              v-if="filter && filter.options.length > 0"
              class="inline-flex items-center justify-center bg-med-navy text-white rounded-full m-1 w-8 h-8"
            >
              {{ filter ? filter.options.length : 0 }}
            </span>
          </span>
          <span class="inline-flex items-center justify-center cursor-pointer">
            <UIcon
              :name="appConfig.ui.icons.chevronDown"
              class="size-5 shrink-0 transition duration-200 align-middle"
              :class="isExpanded ? 'rotate-180' : ''"
              aria-hidden="true"
            />
          </span>
        </div>
      </button>
    </div>
    <div
      v-if="optionList.length > 0 && isExpanded"
      class="pb-4"
    >
      <SearchCategoryOptionBlock
        v-for="option in optionList"
        :key="option.optionCvlIdentifier"
        :model="option"
        :is-selected=" filter ? filter.options.find((element) => element.name === option.optionName.value) : false"
        @remove-filter="removeFilter"
        @add-filter="addFilter"
      />
    </div>
  </div>
</template>
